// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"f377e965","136":"de4fd0ee","478":"4b753ae2","482":"e63d38e1","640":"d5b11aff","649":"80d2ad29","826":"80d2ad29"}[chunkId] + ".chunk.css";
};